import { VoyageRoute, VoyageRoutePointFeature } from "../../models/voyage-routing-model";
import { WhaleZonesModel } from "../../models/whale-zones-model";
import { RouteGeometry } from '../../models/voyage-routing-model';
import { ZoneFeature } from "../../models/zones-base-interfaces";
import { ZonesUtilitiesBase } from "./zones-utilities-base";

export class WhaleZonesUtilities extends ZonesUtilitiesBase {
    zoneID: string = "WHALE ZONE"
    
    async getZones(route?: RouteGeometry): Promise<ZoneFeature[]> {
        const zones = await WhaleZonesModel!.allActiveZones(new Date(route![0].properties.timestamp!), new Date(route![route!.length - 1].properties.timestamp!));
        if (!zones) {
            throw new Error("Could not retreive Whale Zones.");
        }

        return zones;
    }

    setAppliedFlagOnRoute(route: VoyageRoute): void {
        route.route_info!.whaleZonesApplied = true;
    }

    modifyWaypointProperties(waypoint: VoyageRoutePointFeature, zones: ZoneFeature[]): void {
        const speed = Math.min(...zones.map(z => parseFloat(z.properties.speed_limit!) / (60*60 / 1852)));
        waypoint.properties.speed_maximum ? waypoint.properties.speed_maximum = Math.min(waypoint.properties.speed_maximum, speed) : waypoint.properties.speed_maximum = speed;
    }

    restoreOriginalWaypoints() {} // whale zones modify the existing waypoints properties like speed
}
